import AccountModal from "../AccountModal";
import {
  FormikTextField,
  FormikForm,
  FormikSubmit,
  validateRequired,
} from "@/atoms/account/formik";
import styled from "styled-components";

const initialValues = {
  oldpassword: "",
  password1: "",
  password2: "",
};

const validationSchema = validateRequired(Object.keys(initialValues));

const PasswordForm = ({ onSubmit, onSuccess }) => {
  return (
    <FormikForm
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
      onSuccess={onSuccess}
    >
      <FormikTextField
        name={"oldpassword"}
        label={"Old Password"}
        type={"password"}
      />
      <FormikTextField
        name={"password1"}
        label={"New Password"}
        type={"password"}
        autoComplete="new-password"
      />
      <FormikTextField
        name={"password2"}
        label={"Repeat New Password"}
        placeholder={"Re-enter your new password"}
        type={"password"}
        autoComplete="new-password"
      />
      <FormikSubmit label={"Change"} className={"w-full mt-6"} />
    </FormikForm>
  );
};

const PasswordFormContainer = styled.div`
  width: 600px;
  max-width: 100%;
`;

const PasswordChangeModal = ({ isOpen, onClose, onSubmit, onSuccess }) => {
  return (
    <AccountModal isOpen={isOpen} onClose={onClose}>
      <PasswordFormContainer>
        <div className={"modal-title mb-10"}>Change Password</div>
        <PasswordForm onSubmit={onSubmit} onSuccess={onSuccess} />
      </PasswordFormContainer>
    </AccountModal>
  );
};

export default PasswordChangeModal;
